// extracted by mini-css-extract-plugin
export default {"pageContainer":"ProtocolsTabPage_pageContainer__0yVOj"};